export default "__VITE_ASSET__2ba5dca9__"